import { observer } from 'mobx-react-lite'
import classNames from 'classnames'
import { Box } from 'shared/ui/Box'
import { Icon, type IIconsVector } from 'shared/ui/Icon'
import { Typography } from 'shared/ui/Typography'
import styles from './styles.module.scss'

export type ITabsListItem<T = string> = {
  value: T
  label: string
  icon: IIconsVector
}

type ISettingsTabsProps<T = string> = {
  tabsList: ITabsListItem<T>[]
  selectedValue: T
  setSelectedValue: (value: T) => void
  tabsClassName?: string
}

export const SettingsTabs = observer(
  <T extends string>({
    tabsList,
    selectedValue,
    setSelectedValue,
    tabsClassName,
  }: ISettingsTabsProps<T>) => {
    return (
      <Box display='flex' gap={1}>
        {tabsList.map((item) => {
          const isSelected = item.value === selectedValue
          return (
            <div
              key={item.value}
              className={classNames(
                styles.tabsItem,
                {
                  [styles.selected]: isSelected,
                },
                tabsClassName
              )}
              onClick={() => setSelectedValue(item.value)}
            >
              <Icon
                icon={item.icon as IIconsVector}
                className={classNames(styles.tabsItemIcon, {
                  [styles.tabsItemIconSelected]: isSelected,
                })}
              />
              <Typography
                variant='body-md-medium'
                color={
                  isSelected ? 'var(--content-brand-secondary)' : 'var(--content-primary-primary)'
                }
                ariaLabel={item.label}
              >
                {item.label}
              </Typography>
            </div>
          )
        })}
      </Box>
    )
  }
)
